import React from "react";

function Header() {
  return (
    <div className="mx-auto bottom-0 pl-2 pb-2 header ">
        <h1 className="display-1 text-start" style={{color: "white", textShadow: "0px 0px 3px black"}}>A new approach to literacy instruction</h1>
        <h5 className="text-start display-5" style={{color: "white", fontSize: "50p", textShadow: "0px 0px 3px black"}}>Making learning a social activity</h5>
    </div>
  );
}


export default Header
